import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { Helmet } from 'react-helmet-async';
import { Permission } from '@/models/user';
import { PageWithLayout } from '@/models/page';
import { VoucherTemplateEditorContent } from '@starjack/widgets/voucherTemplates';
import { useAuthentication } from '@starjack/features/authentication';
import { VoucherToolGuard } from '@/guards/VoucherToolGuard';

const VoucherTemplateEditor: PageWithLayout = () => {
    const { liftOperatorData } = useAuthentication();

    return (
        <VoucherToolGuard>
            <Helmet>
                <title>Gutscheinvorlage bearbeiten | Starjack Admin</title>
            </Helmet>

            <VoucherTemplateEditorContent
                liftOperatorId={liftOperatorData?.liftOperatorId}
            />
        </VoucherToolGuard>
    );
};

VoucherTemplateEditor.getLayout = (page) => (
    <SidebarLayout>{page}</SidebarLayout>
);

VoucherTemplateEditor.isProtected = true;

VoucherTemplateEditor.permissions = [Permission.VOUCHER_TEMPLATE_NAV];

export default VoucherTemplateEditor;
